import { useTranslate } from '@tolgee/react';
import { useMemo } from 'react';

interface Props {
  isTokoMigrate2TT?: boolean;
}

function AuthInvalid(props: Props) {
  const { isTokoMigrate2TT } = props;
  const { t } = useTranslate();

  const text = useMemo(() => {
    if (isTokoMigrate2TT) {
      return t('当前店铺已迁移至Tiktok，请尽快联系管理重新添加Tiktok店铺');
    }
    return t('storeSelector.当前店铺收发消息、订单同步异常，请尽快联系管理重新添加店铺');
  }, [isTokoMigrate2TT, t]);

  return (
    <div className="w-full px-[8px] py-[10px] flex items-center justify-between leading-[20px] bg-[#ffe492]">
      {text}
    </div>
  );
}

export default AuthInvalid;
